var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vx-card", { staticClass: "mb-4" }, [
        _c("div", { staticClass: "flex flex-col gap-4" }, [
          _c(
            "div",
            { staticClass: "flex flex-col gap-2" },
            [
              _c("validation-observer", {
                ref: "validatorForm",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var valid = ref.valid
                      return [
                        _c(
                          "b-form",
                          {
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.createOrUpdate($event)
                              }
                            }
                          },
                          [
                            _c("validation-provider", {
                              staticClass: "flex-grow",
                              attrs: {
                                name: _vm.$t("newsletter.workflow.name"),
                                rules: "required",
                                slim: ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              id: "input-group-1",
                                              label: _vm.$t(
                                                "newsletter.workflow.name"
                                              ),
                                              "label-for":
                                                "newsletter_workflow_name"
                                            }
                                          },
                                          [
                                            _c("b-form-input", {
                                              staticClass: "required",
                                              attrs: {
                                                id: "newsletter_workflow_name",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null,
                                                name: "newsletter_workflow_name"
                                              },
                                              model: {
                                                value: _vm.model.name,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "model.name"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "input-group-1",
                                  label: _vm.$t(
                                    "newsletter.workflow.description"
                                  ),
                                  "label-for": "newsletter_workflow_description"
                                }
                              },
                              [
                                _c("b-form-textarea", {
                                  attrs: {
                                    id: "newsletter_workflow_description",
                                    rows: "4"
                                  },
                                  model: {
                                    value: _vm.model.description,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "description", $$v)
                                    },
                                    expression: "model.description"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("h5", { staticClass: "mt-4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("newsletter.workflow.report_config")
                                )
                              )
                            ]),
                            _c("vs-divider", { attrs: { color: "warning" } }),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "input-group-1",
                                  label: _vm.$t(
                                    "newsletter.workflow.report_title"
                                  ),
                                  "label-for":
                                    "newsletter_workflow_report_title"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "newsletter_workflow_report_title"
                                  },
                                  model: {
                                    value: _vm.model.report_title,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "report_title", $$v)
                                    },
                                    expression: "model.report_title"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "input-group-1",
                                  label: _vm.$t(
                                    "newsletter.workflow.report_subtitle"
                                  ),
                                  "label-for":
                                    "newsletter_workflow_report_subtitle"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "newsletter_workflow_report_subtitle"
                                  },
                                  model: {
                                    value: _vm.model.report_subtitle,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "report_subtitle",
                                        $$v
                                      )
                                    },
                                    expression: "model.report_subtitle"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  id: "input-group-1",
                                  label: _vm.$t(
                                    "newsletter.workflow.text_against_layer"
                                  ),
                                  "label-for":
                                    "newsletter_workflow_text_against_layer"
                                }
                              },
                              [
                                _c("simple-editor", {
                                  staticClass: "mb-2",
                                  model: {
                                    value: _vm.model.text_against_layer,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "text_against_layer",
                                        $$v
                                      )
                                    },
                                    expression: "model.text_against_layer"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "w-full flex gap-2 justify-end" },
            [
              !_vm.isEdit()
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "newsletter_workflows.create",
                          expression: "'newsletter_workflows.create'"
                        }
                      ],
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.validateForm
                      },
                      on: { click: _vm.createOrUpdate }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("action.save")) + " ")]
                  )
                : _vm._e(),
              _vm.isEdit()
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "newsletter_workflows.edit",
                          expression: "'newsletter_workflows.edit'"
                        }
                      ],
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.validateForm
                      },
                      on: { click: _vm.createOrUpdate }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("action.save")) + " ")]
                  )
                : _vm._e(),
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { variant: "outline-secondary" },
                  on: { click: _vm.goBack }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "CornerUpLeftIcon" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v(_vm._s(_vm.$t("back")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }